module.exports = require("live/components/widget/config/forms/boolean-field");